/** Contact page: live open or closed badge, the call card note, and today's row in the hours table. Times are Central. The page reads fine without this file. */

(function () {
  const badge = document.querySelector('[data-hours-badge]');
  if (!badge) return;
  const text = badge.querySelector('[data-hours-text]');
  const sub = document.querySelector('[data-call-sub]');
  const rows = document.querySelectorAll('[data-hours-table] tr');
  const HOURS = { 0: null, 1: [10, 18], 2: [10, 18], 3: [10, 18], 4: [10, 18], 5: [10, 18], 6: [12, 16] };
  const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function hour12(h) {
    return (h > 12 ? h - 12 : h) + (h >= 12 ? 'pm' : 'am');
  }

  function nowCentral() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  }

  function update() {
    const now = nowCentral();
    const day = now.getDay();
    const mins = now.getHours() * 60 + now.getMinutes();
    const slot = HOURS[day];
    const open = slot && mins >= slot[0] * 60 && mins < slot[1] * 60;

    if (open) {
      badge.className = 'contact-hours__badge is-open';
      text.textContent = 'Open now until ' + hour12(slot[1]);
      if (sub) sub.textContent = sub.dataset.open;
    } else {
      badge.className = 'contact-hours__badge is-closed';
      let label = '';
      if (slot && mins < slot[0] * 60) {
        label = 'Opens today at ' + hour12(slot[0]);
      } else {
        for (let i = 1; i <= 7; i++) {
          const next = (day + i) % 7;
          if (HOURS[next]) {
            label = 'Opens ' + (i === 1 ? 'tomorrow' : DAYS[next]) + ' at ' + hour12(HOURS[next][0]);
            break;
          }
        }
      }
      text.textContent = label;
      if (sub) sub.textContent = sub.dataset.closed;
    }
    badge.hidden = false;
    rows.forEach((row) => row.classList.toggle('is-today', Number(row.dataset.day) === day));
  }

  update();
  setInterval(update, 60000);
})();
